import _ from 'lodash';

// Replacement for angular.isDefined()
const isDefined = (value) => {
    return typeof value !== 'undefined';
};

function Vehicle(data) {
    if (data) {
        _.extend(this, data);
    }

    if (!isDefined(this.costNew)) {
        this.costNew = {
            amount: 0,
            currency: 'usd'
        };
    }

    if (!isDefined(this.lastVehicleInspection_ML)) {
        this.lastVehicleInspection_ML = {};
    }
    if (_.isUndefined(this.additionalInterests_ML)) {
        this.additionalInterests_ML = [];
    }
}

Vehicle.prototype.getDisplayName = function () {
    let name = this.make || '';
    if (this.model) {
        if (name) {
            name += ' ';
        }
        name += this.model;
    }
    if (this.year) {
        if (name) {
            name += ' ';
        }
        name += this.year;
    }
    if (name.length < 1) {
        name = 'Unnamed';
    } else if (this.license !== '0streamlinedquote0') {
        if (this.license) {
            name += ' (';
            name += this.license;
            if (this.licenseState) {
                name += '/';
                name += this.licenseState;
            }
            name += ')';
        }
    }
    return name;
};

Vehicle.prototype.getYearMakeModelNameML = function () {
    let name = this.year || '';
    if (this.make) {
        if (name) {
            name += ' ';
        }
        name += this.make;
    }
    if (this.model) {
        if (name) {
            name += ' ';
        }
        name += this.model;
    }

    if (name.length < 1) {
        name = 'Unnamed';
    }

    return name;
};

Vehicle.prototype.getYearMakeNameML = function () {
    let name = this.year || '';
    if (this.make) {
        if (name) {
            name += ' ';
        }
        name += this.make;
    }

    if (name.length < 1) {
        name = 'Unnamed';
    }

    return name;
};

Vehicle.prototype.getVehicleStatesForCountry = function (states, countryCode) {
    return _.filter(states, (state) => {
        const countryConstraint = _.find(state.categories, (constraint) => {
            return _.keys(constraint).indexOf('Country') !== -1;
        });
        if (countryConstraint) {
            return countryConstraint.Country === countryCode;
        }
        return false;
    });
};

Vehicle.prototype.getFixedId = function () {
    return this.fixedId;
};

export default Vehicle;
